module.exports = new Promise(resolve => {
    let appUrl = "";
    try {
      const parsedUrl = new URL(window.location);
      const segments = parsedUrl.pathname.split('/');
      const keyword = segments[1];
      appUrl = keyword;
    } catch (error) {
      console.error('<--- Invalid URL: --->', error);
    }
    console.log("appUrl-->", appUrl, typeof appUrl)
    if(appUrl ==="" || appUrl !== "ams"){
      console.error('<--- Resolving Null Proxy --->');
      resolve(null)
    }else{
const script = document.createElement('script')
      script.src = "https://ggapp-frontend.dutamoney.co.id/ams-app/remoteEntry.js";
      script.onerror = (e) => {console.error('<-- Error loading agentmanagement remote from shell app -->', e, script.src)};
      script.onload = () => {
        // the injected script has loaded and is available on window
        // we can now resolve this Promise
        const proxy = {
          get: (request) => window.agentmanagement.get(request),
          init: (...arg) => {
            try {
              return window.agentmanagement.init(...arg)
            } catch(e) {
              console.log('remote container already initialized')
            }
          }
        }
        resolve(proxy)
      }
      // inject this script with the src set to the versioned remoteEntry.js
      document.head.appendChild(script);
    }
    })
    ;